// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.
//
// D-POT-5 — the one JSON request helper the POT screens share (POT classic's potApi.ts and the
// OwlRx Plan of Treatment form). api/client.ts is frozen (E-05), so this rides apiFetch and raises
// the same `Error & { status, body }` shape ApiError consumers read (`.body`, never `.payload`).
import { apiFetch } from '../../api/client'

export async function potRequest<T>(method: string, path: string, body?: unknown): Promise<T> {
  const res = await apiFetch(path, { method, headers: body !== undefined ? { 'Content-Type': 'application/json' } : undefined, body: body !== undefined ? JSON.stringify(body) : undefined })
  if (!res.ok) {
    let payload: unknown = null
    try { payload = await res.json() } catch { /* no body */ }
    const err = new Error((payload as { message?: string; error?: string } | null)?.message || (payload as { error?: string } | null)?.error || `http_${res.status}`) as Error & { status: number; body: unknown }
    err.status = res.status; err.body = payload
    throw err
  }
  if (res.status === 204) return undefined as T
  return res.json() as Promise<T>
}

/** The server message for a failed call (`ApiError.body`), falling back to the Error text. */
export function apiErrorMessage(e: unknown, fallback = 'Request failed'): string {
  const b = (e as { body?: { message?: string; error?: string } } | null)?.body
  return b?.message ?? b?.error ?? (e as Error | null)?.message ?? fallback
}
